import { api } from './api'; // Importa a instância configurada do Axios

/**
 * Busca as estatísticas consolidadas para os cards do dashboard.
 * A autenticação é gerenciada pelo interceptor do Axios na instância `api`.
 * @returns {Promise<object>} Os dados das estatísticas do dashboard.
 */
export const getDashboardStats = async (scopeQuery = "") => {
  try {
    const endpoint = scopeQuery ? `/dashboard/stats?${scopeQuery}` : "/dashboard/stats";
    const response = await api.get(endpoint);
    return response; // O interceptor do Axios já extrai o `data`
  } catch (error) {
    console.error("Erro ao buscar estatísticas do dashboard:", error);
    // Propaga o erro para que o componente que chamou possa tratá-lo
    throw error;
  }
};
